export const ACTUATOR_CHART_COLORS = [
  '#42a5f5',
  '#ef5350',
  '#344767',
  '#9e9e9e',
  '#f57c00',
  '#66bb6a',
  '#ab47bc',
  '#26c6da',
  '#8d6e63',
  '#78909c',
  '#ffa726',
  '#7e57c2',
];

export function normalizeActuatorName(name: string): string {
  return name.trim().toLowerCase();
}

export function buildActuatorColorMap(names: string[]): Map<string, string> {
  const uniqueNames = [...new Set(names.map(normalizeActuatorName).filter(Boolean))]
    .sort((a, b) => a.localeCompare(b, 'de'));

  const colorMap = new Map<string, string>();
  uniqueNames.forEach((name, index) => {
    colorMap.set(name, ACTUATOR_CHART_COLORS[index % ACTUATOR_CHART_COLORS.length]);
  });

  return colorMap;
}

export function getActuatorColor(name: string, colorMap: Map<string, string>): string {
  const normalized = normalizeActuatorName(name);
  if (colorMap.has(normalized)) {
    return colorMap.get(normalized)!;
  }

  const fallbackIndex = normalized
    .split('')
    .reduce((sum, char) => sum + char.charCodeAt(0), 0);

  return ACTUATOR_CHART_COLORS[fallbackIndex % ACTUATOR_CHART_COLORS.length];
}

export function getActuatorColors(names: string[], colorMap: Map<string, string>): string[] {
  return names.map((name) => getActuatorColor(name, colorMap));
}
